const ENCODED_WHITESPACE = encodeURIComponent(' ');

const replaceWhiteSpaceCharactersWithEncoded = (url: string) => {
  return (url || '').replace(/\s/g, ENCODED_WHITESPACE);
};

export { replaceWhiteSpaceCharactersWithEncoded };
